// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s5-0";
export var fileList = "_s5-2";
export var removeFileButton = "_s5-1";